import { render, staticRenderFns } from "./NewEditor.vue?vue&type=template&id=5f83a067&scoped=true&"
import script from "./NewEditor.vue?vue&type=script&lang=js&"
export * from "./NewEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f83a067",
  null
  
)

export default component.exports